import React, { useState } from "react";
import {
  Box,
  Grid2,
  Typography,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import RoleSelectionModal from "../feature/Login/skillvationLogins/RoleSectionModal";

const SkillVationAuthLayout = ({
  title,
  subtitle,
  bottomText,
  bottomLinkLabel,
  bottomLinkTo,
  children,
}) => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);

  // Handle sign-up button click
  const handleSignUpClick = (e) => {
    e.preventDefault();
    setModalOpen(true);
  };

  // Handle modal close
  const handleModalClose = () => {
    setModalOpen(false);
  };


  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#fff",
      }}
    >
      <Grid2
        container
        sx={{
          width: "95%",
          overflow: "hidden",
        }}
      >
        {/* Left Side */}
        <Grid2
          size={{ xs: 0, md: 7 }}
          sx={{
            display: { xs: "none", md: "flex" },
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              flex: 1,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
              position: "relative",
              left: "5%",
              top: "-7%",
            }}
          >
            <Box
              component="img"
              src="/Group.png"
              alt="login-group"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
              }}
            />
          </Box>

          <Box
            sx={{
              textAlign: "center",
              position: "relative",
              left: "-3%",
              top: "-7%",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                color: "#1e293b",
                fontSize: "18px",
              }}
            >
              Sign Up to My Skill
            </Typography>

            <Typography
              sx={{
                fontSize: "14px",
                color: "#64748b",
                mt: 1,
              }}
            >
              If you don't have an account you can{" "}
              <Button
                variant="text"
               onClick={handleSignUpClick}
                sx={{
                  textTransform: "none",
                  minWidth: "auto",
                  p: 0,
                  color: "#3b82f6",
                }}
              >
                Register here !!
              </Button>
            </Typography>
          </Box>
        </Grid2>

        {/* Right Side */}
        <Grid2
          size={{ xs: 12, md: 5 }}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            px: { xs: 2, md: 5 },
            py: 4,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: "#0f172a",
            }}
          >
            {title}
          </Typography>

          <Typography
            sx={{
              color: "#64748b",
              fontSize: "14px",
              mt: 1,
              mb: 4,
            }}
          >
            {subtitle}
          </Typography>

          {children}

          {/* Divider */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              my: 3,
            }}
          >
            <Box
              sx={{
                flex: 1,
                height: "1px",
                bgcolor: "#e2e8f0",
              }}
            />

            <Typography
              sx={{
                fontSize: "12px",
                color: "#94a3b8",
              }}
            >
              Or
            </Typography>

            <Box
              sx={{
                flex: 1,
                height: "1px",
                bgcolor: "#e2e8f0",
              }}
            />
          </Box>

          <Typography
            sx={{
              textAlign: "center",
              fontSize: "14px",
              color: "#64748b",
            }}
          >
            {bottomText}{" "}
            <Button
              variant="text"
              onClick={() =>
                navigate(`${bottomLinkTo}${window.location.search}`)
              }
              sx={{
                textTransform: "none",
                minWidth: "auto",
                p: 0,
                color: "#3b82f6",
              }}
            >
              {bottomLinkLabel}
            </Button>
          </Typography>
        </Grid2>
      </Grid2>

      <RoleSelectionModal
        open={modalOpen}
        onClose={handleModalClose}
      />
    </Box>
  );
};

export default SkillVationAuthLayout;